import Entity from "lib/models/Entity";
import { computed } from "mobx";

interface EntityTypeSource {
  entity: string;
  entityType: string;
}

interface EntityTypedText {
  type: string;
  words: string[];
}

export default class EntityType extends Entity<EntityTypeSource> {
  @computed
  get entity(): string {
    return this.source.entity;
  }

  @computed
  get entityType(): string {
    return this.source.entityType;
  }
}

export type { EntityTypeSource, EntityTypedText };
